import {
  HIDE_MAP_INFO_BUBBLE,
  SHOW_MAP_INFO_BUBBLE,
  SWITCH_TAB,
  TOGGLE_FILTERS,
  TOGGLE_ALERT,
  TOGGLE_MAP_LIST,
  SHOW_OVERLAY_FILTERS,
  HIDE_OVERLAY_FILTERS,
  ENABLE_TRANSFER_RECORDS,
  DISABLE_TRANSFER_RECORDS
} from '../actions/ui';

export default function (state = {}, action) {
  switch (action.type) {
  case HIDE_MAP_INFO_BUBBLE:
    return { ...state, activeMapProperty: null, showMapInfoWindow: false };
  case SHOW_MAP_INFO_BUBBLE:
    return { ...state, activeMapProperty: action.property, showMapInfoWindow: true };
  case SWITCH_TAB:
    return { ...state, currentTab: action.tab };
  case TOGGLE_FILTERS:
    return { ...state, filtersVisible: !state.filtersVisible };
  case TOGGLE_ALERT:
    return { ...state, alertMessage: action.message, error: action.error };
  case TOGGLE_MAP_LIST:
    return { ...state, showMapList: !state.showMapList };
  case SHOW_OVERLAY_FILTERS:
    return { ...state, showColumnFilters: true };
  case HIDE_OVERLAY_FILTERS:
    return { ...state, showColumnFilters: false };      
  case ENABLE_TRANSFER_RECORDS:
    return { ...state, canTransferRecords: true };
  case DISABLE_TRANSFER_RECORDS:
    return { ...state, canTransferRecords: false };      
  default:
    return state;
  }
}
